import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import diff from 'object-diff';
import update from 'immutability-helper';
import MemberDetailForm from './MemberDetailForm';
import MemberDetail from './MemberDetail';

function getInitialValues(member) {
  // Shim tour group obj to work with redux-form better
  if (member.group) {
    return update(member, {
      group: {
        $set: member.group.id,
      },
    });
  }
  return member;
}
class MemberDetailModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
  }
  handleSubmit(values) {
    const initialValues = getInitialValues(this.props.member);
    const isNew = this.props.member.id ? false : true;
    if (isNew) {
      return this.handleAddMember(values, initialValues);
    }
    return this.handleEditMember(values, initialValues);
  }
  handleAddMember(values, initialValues) {
    let submitValues;
    if (values.group) {
      submitValues = values;
      submitValues.group = { id: values.group };
    } else {
      submitValues = values;
    }
    submitValues.tour_id = this.props.tourId;
    this.props.addMember(submitValues);
    this.props.onClose();
  }
  handleEditMember(values, initialValues) {
    const submitValues = diff(initialValues, values);
    if (submitValues.group) {
      const groupId = submitValues.group;
      submitValues.tour_id = this.props.tourId;
      submitValues.group = { id: groupId };
    }
    this.props.editMember(this.props.member.id, submitValues);
    this.props.onClose();
  }
  handleCancel(event) {
    event.preventDefault();
    this.props.onClose();
  }
  handleAdd(event) {
    event.preventDefault();
    this.props.onClose();
  }
  handleRemoveMember() {
    this.props.dispatchRemoveMemberFromGroup(this.props.member.group.id, this.props.member.id);
    this.props.onClose();
  }

  renderDetail() {
    const modalLabel = 'Member Detail';
    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MemberDetail member={this.props.member} />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
  renderForm() {
    const isNew = this.props.member.id ? false : true;
    const modalLabel = isNew ? 'Add Member' : 'Edit Member';
    const groups = [];
    this.props.groups.forEach(group => {
      groups.push({
        label: group.name,
        value: group.id,
      });
    });
    const initialValues = getInitialValues(this.props.member);

    return (
      <Modal show={this.props.show} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalLabel}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MemberDetailForm
            member={this.props.member}
            initialValues={initialValues}
            onSubmit={this.handleSubmit}
            handleRemove={this.handleRemoveMember}
            groups={groups}
            isNew={isNew}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
  render() {
    if (this.props.readOnly) {
      return this.renderDetail();
    }
    return this.renderForm();
  }
}

MemberDetailModal.propTypes = {
  tourId: PropTypes.number.isRequired,
  member: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.String,
    tag_line: PropTypes.String,
  }).isRequired,
  groups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.String,
    })
  ).isRequired,
  show: PropTypes.bool.isRequired,
  addMember: PropTypes.func.isRequired,
  editMember: PropTypes.func.isRequired,
  dispatchRemoveMemberFromGroup: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default MemberDetailModal;



// WEBPACK FOOTER //
// src/routes/tours/components/MemberDetailModal.js